import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const officers = [
  { name: '押谷 小助', role: '会長', org: '株式会社山正' },
  { name: '小倉 洋介', role: '副会長', org: 'セイリン株式会社' },
  { name: '松尾 知美', role: '副会長', org: '株式会社いっしん' },
  { name: '丸山 哲司', role: '理事', org: '株式会社カナケン' },
  { name: '中田 啓太郎', role: '理事', org: '株式会社前田豊吉商店' },
  { name: '上島 一晃', role: '理事', org: '日進医療器株式会社' },
  { name: '今里 秀俊', role: '監事', org: '株式会社チュウオー' },
  { name: '松尾 浩紀', role: '理事', org: 'ダイヤ工業株式会社' },
  { name: '松本 良世', role: '理事', org: '株式会社日本特殊医科' },
];

const orgInfo = [
  { label: '正式名称', value: '一般社団法人東洋医学未来推進協会' },
  { label: '英語名称', value: 'Oriental Medicine Future Expand Society (OMFES)' },
  { label: '設立日', value: '2025年4月1日（2026年4月1日 一般社団法人化）' },
  {
    label: '所在地',
    value: '東京都千代田区神田須田町一丁目十六ー五 ヒューリック神田ビル７階 セイリン㈱東京オフィス内',
  },
];

export default function AboutPage() {
  return (
    <main>
      <Navbar />

      {/* Page Hero */}
      <section className="relative pt-32 pb-20 bg-forest-800 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="/images/about.jpeg"
            alt="協会について"
            className="w-full h-full object-cover object-top opacity-30"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-forest-800/60 to-forest-800/90" />
        </div>
        {/* Ripple decoration */}
        <div className="absolute right-10 top-1/2 -translate-y-1/2 pointer-events-none opacity-10 hidden lg:block">
          <div className="relative w-48 h-48">
            <div className="absolute inset-0 rounded-full border-2 border-cream-200" />
            <div className="absolute inset-5 rounded-full border border-cream-200" />
            <div className="absolute inset-10 rounded-full border border-cream-200" />
            <div className="absolute inset-16 rounded-full border border-cream-200" />
          </div>
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-8 h-px bg-cream-400/50" />
            <span className="text-cream-400/60 text-xs font-serif tracking-widest2">ABOUT OMFES</span>
          </div>
          <h1 className="text-cream-100 font-serif font-light text-4xl md:text-5xl tracking-wider">
            協会について
          </h1>
        </div>
      </section>

      {/* Organization Info */}
      <section className="bg-cream-100 py-20 md:py-24">
        <div className="max-w-5xl mx-auto px-6 lg:px-10">
          <div className="text-center mb-14">
            <div className="inline-block border border-forest-600/30 px-6 py-1.5 mb-5">
              <span className="text-forest-600 text-xs font-serif tracking-widest2">ORGANIZATION</span>
            </div>
            <h2 className="text-forest-800 font-serif font-light text-3xl tracking-wider">団体概要</h2>
          </div>

          <div className="bg-white border border-cream-300 divide-y divide-cream-300">
            {orgInfo.map((item) => (
              <div key={item.label} className="flex flex-col sm:flex-row">
                <dt className="w-full sm:w-48 flex-shrink-0 px-6 py-4 bg-cream-200/60 text-forest-700 text-sm font-serif tracking-wider">
                  {item.label}
                </dt>
                <dd className="flex-1 px-6 py-4 text-forest-800 text-sm font-serif leading-relaxed">
                  {item.value}
                </dd>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Philosophy */}
      <section id="philosophy" className="bg-cream-200 py-20 md:py-24 relative overflow-hidden">
        <div className="absolute left-0 top-0 bottom-0 w-1 bg-forest-600/20" />
        <div className="max-w-4xl mx-auto px-6 lg:px-10">
          <div className="text-center mb-14">
            <div className="inline-block border border-forest-600/30 px-6 py-1.5 mb-5">
              <span className="text-forest-600 text-xs font-serif tracking-widest2">PHILOSOPHY</span>
            </div>
            <h2 className="text-forest-800 font-serif font-light text-3xl tracking-wider">設立趣旨</h2>
          </div>

          <article className="text-forest-800 font-serif text-sm leading-loose space-y-5 tracking-wide">
            <p>
              わが国の医療をとりまく現状は、急速な高齢化と医療需要の多様化、医療費の増大といった構造的課題に直面しており、
              西洋医学のみならず、伝統医学・補完代替医療への社会的関心は日増しに高まっています。
              なかでも鍼灸・漢方・柔道整復などを包含する東洋医学は、長い歴史と豊かな臨床的知見を持ちながら、
              その学術的評価や社会的認知においては、いまだ十分とはいえない状況にあります。
            </p>
            <p>
              こうした背景のもと、東洋医学に関わる施術者・研究者・教育機関・企業・関連団体が一堂に集い、
              互いの知識・技術・資源を共有しながら、学術的根拠の蓄積と社会への普及啓発を一体的に推進する組織の必要性を、
              私どもは強く感じてまいりました。
            </p>
            <p>
              東洋医学の価値は、治療技術としての有効性にとどまらず、予防医学・健康増進・生活の質の向上という観点からも、
              これからの時代に欠かせない役割を担うものと確信しております。
              しかしながら、業界の枠を超えた横断的な連携はいまだ限られており、情報発信や政策提言の面でも、
              一体的な組織基盤が求められてきました。
            </p>
            <p>
              そのような課題認識から、私どもは東洋医学に携わるすべての関係者が参画できる開かれたプラットフォームとして、
              本協会を設立するに至りました。学術大会の支援・共催、業界内外との連携推進、普及広報活動、
              そして次世代の施術者・研究者の育成を通じて、東洋医学の持続可能な発展と社会への貢献を果たしてまいります。
            </p>
            <p>
              以上の主旨のもと、団体の設立に向けて皆様にはご理解をいただき、ご協力を賜りますようお願い申し上げます。
            </p>
          </article>
        </div>
      </section>

      {/* Representative Message */}
      <section className="bg-cream-100 py-20 md:py-24">
        <div className="max-w-5xl mx-auto px-6 lg:px-10">
          <div className="text-center mb-14">
            <div className="inline-block border border-forest-600/30 px-6 py-1.5 mb-5">
              <span className="text-forest-600 text-xs font-serif tracking-widest2">MESSAGE</span>
            </div>
            <h2 className="text-forest-800 font-serif font-light text-3xl tracking-wider">代表挨拶</h2>
          </div>

          <div className="bg-white border border-cream-300 p-10 md:p-14 text-center">
            <div className="w-24 h-24 flex items-center justify-center rounded-full border-2 border-cream-300 mx-auto mb-6">
              <i className="ri-user-3-line text-forest-500/40 text-3xl" />
            </div>
            <p className="text-forest-500/70 text-sm font-serif tracking-widest mb-2">準備中</p>
            <p className="text-forest-400/50 text-xs font-serif">
              代表挨拶は後日掲載いたします。しばらくお待ちください。
            </p>
          </div>
        </div>
      </section>

      {/* Officers */}
      <section id="officers" className="bg-forest-800 py-20 md:py-24">
        <div className="max-w-5xl mx-auto px-6 lg:px-10">
          <div className="text-center mb-14">
            <div className="inline-block border border-cream-400/30 px-6 py-1.5 mb-5">
              <span className="text-cream-400/60 text-xs font-serif tracking-widest2">OFFICERS</span>
            </div>
            <h2 className="text-cream-100 font-serif font-light text-3xl tracking-wider">役員一覧</h2>
            <div className="mt-8">
              <img
                src="/images/yakuin.jpg"
                alt="役員一覧"
                className="mx-auto max-w-full rounded"
              />
            </div>
          </div>

          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-forest-600/50">
                  <th className="text-left py-3 px-6 text-cream-400/60 text-xs font-serif tracking-widest font-normal">氏名</th>
                  <th className="text-left py-3 px-6 text-cream-400/60 text-xs font-serif tracking-widest font-normal">役職</th>
                  <th className="text-left py-3 px-6 text-cream-400/60 text-xs font-serif tracking-widest font-normal">所属企業</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-forest-700/40">
                {officers.map((officer) => (
                  <tr key={officer.name} className="hover:bg-forest-700/30 transition-colors duration-150">
                    <td className="py-4 px-6 text-cream-200 text-sm font-serif tracking-wider whitespace-nowrap">
                      {officer.name}
                    </td>
                    <td className="py-4 px-6 whitespace-nowrap">
                      <span className={`text-xs font-serif px-3 py-1 rounded-sm border whitespace-nowrap ${
                        officer.role === '会長'
                          ? 'border-gold-500/50 text-gold-400 bg-gold-600/10'
                          : officer.role === '副会長'
                          ? 'border-forest-400/50 text-forest-300 bg-forest-600/20'
                          : officer.role === '監事'
                          ? 'border-cream-500/40 text-cream-400 bg-cream-400/10'
                          : 'border-forest-500/30 text-forest-300/80'
                      }`}>
                        {officer.role}
                      </span>
                    </td>
                    <td className="py-4 px-6 text-cream-400/80 text-sm font-serif">
                      {officer.org}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
}
